// extracted by mini-css-extract-plugin
export var cardIcon = "_86-5";
export var cardIconUnframed = "_86-9";
export var checkboxCard = "_86-0";
export var checkboxCardSelected = "_86-4";
export var disabled = "_86-2";
export var interactive = "_86-1";
export var outerBorder = "_86-3";
export var spacerMedium = "_86-8";
export var spacerSmall = "_86-7";
export var spacerXsmall = "_86-6";